import { lazy } from 'react';
import {
  Activity, Building2, Contact, Database, DollarSign, Mail, Settings, SlidersHorizontal, Users,
} from 'lucide-react';

// Une vue par écran, chargée à la demande (Audit embarque Recharts ; Clients et
// Interlocuteurs parlent au référentiel central et n'ont aucune donnée locale).
const RatesView = lazy(() => import('./RatesView.jsx'));
const MappingView = lazy(() => import('./MappingView.jsx'));
const ClientsView = lazy(() => import('./ClientsView.jsx'));
const ContactsView = lazy(() => import('./ContactsView.jsx'));
const UsersView = lazy(() => import('./UsersView.jsx'));
const SettingsView = lazy(() => import('./SettingsView.jsx'));
const DirectionThresholdsView = lazy(() => import('./DirectionThresholdsView.jsx'));
const MailTemplatesView = lazy(() => import('./MailTemplatesView.jsx'));
const AuditView = lazy(() => import('./AuditView.jsx'));

/**
 * Menu d'administration groupé par thème (synotis-support#4), sur le modèle
 * d'`ADMIN_GROUPS` de synolog. Les clés sont aussi les slugs d'URL
 * (`/admin-users`…) : un contrat public, ne pas les renommer sans alias dans
 * `LEGACY_SLUGS` (`lib/routes.js`).
 */
export const ADMIN_GROUPS = [
  {
    label: 'Métier',
    items: [
      { key: 'admin-rates', label: 'Tarifs (CJM / TJM)', Icon: DollarSign, Component: RatesView },
      { key: 'admin-mapping', label: 'Mapping consultants', Icon: Database, Component: MappingView },
      { key: 'admin-clients', label: 'Clients (référentiel central)', Icon: Building2, Component: ClientsView },
      { key: 'admin-contacts', label: 'Interlocuteurs', Icon: Contact, Component: ContactsView },
    ],
  },
  {
    label: 'Système',
    items: [
      { key: 'admin-users', label: 'Utilisateurs', Icon: Users, Component: UsersView },
      { key: 'admin-settings', label: 'Paramètres', Icon: Settings, Component: SettingsView },
      { key: 'admin-direction', label: 'Seuils Direction', Icon: SlidersHorizontal, Component: DirectionThresholdsView },
      { key: 'admin-mail-templates', label: "Modèles d'email", Icon: Mail, Component: MailTemplatesView },
      { key: 'admin-audit', label: 'Audit / Activité', Icon: Activity, Component: AuditView },
    ],
  },
];

/** Écrans admin aplatis pour le routage : la garde ADMIN est forcée ici. */
export const ADMIN_VIEWS = ADMIN_GROUPS.flatMap((g) => g.items.map((item) => ({ ...item, adminOnly: true })));
